import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import ContentLoader from 'react-content-loader';

const Header = () => {
  const themeContext = useContext(ThemeContext);
  return (
    <ContentLoader
      backgroundColor={themeContext?.loadingTableColor}
      foregroundColor={themeContext?.loadingTableColorLight}
      backgroundOpacity={1}
      foregroundOpacity={0.5}
      width="100%"
      height="40"
      speed={1.2}
      preserveAspectRatio="xMinYMin"
    >
      <rect x="30" y={0} rx="5" ry="5" width="200" height="20" />
      <rect x="42%" y={0} rx="5" ry="5" width="70" height="20" />
      <rect x="50%" y={0} rx="5" ry="5" width="50" height="20" />
      <rect x="55%" y={0} rx="5" ry="5" width="50" height="20" />
      <rect x="60%" y={0} rx="5" ry="5" width="100" height="20" />
      <rect x="70%" y={0} rx="5" ry="5" width="100" height="20" />
      <rect x="80%" y={0} rx="5" ry="5" width="70" height="20" />
      <rect x="86%" y={0} rx="5" ry="5" width="50" height="20" />
      <rect x="95%" y={0} rx="5" ry="5" width="50" height="20" />
    </ContentLoader>
  );
};
const Table = () => {
  const themeContext = useContext(ThemeContext);
  return (
    <ContentLoader
      backgroundColor={themeContext?.loadingTableColor}
      foregroundColor={themeContext?.loadingTableColorLight}
      backgroundOpacity={1}
      foregroundOpacity={0.5}
      width="100%"
      height="95%"
      speed={1.2}
      preserveAspectRatio="xMinYMin"
    >
      {Array(10)
        .fill('')
        .map((e, row) => (
          <React.Fragment key={row}>
            <rect x="0" y={0 + 50 * row} rx="0" ry="0" width="10" height="45" />
            <rect
              x="20"
              y={20 + 50 * row}
              rx="5"
              ry="5"
              width={Math.random() * (400 - 100) + 100}
              height="10"
            />
            <rect
              x="40%"
              y={5 + 50 * row}
              rx="5"
              ry="5"
              width="120"
              height="30"
            />
            <rect
              x="50%"
              y={20 + 50 * row}
              rx="5"
              ry="5"
              width="50"
              height="10"
            />
            <rect
              x="55%"
              y={20 + 50 * row}
              rx="5"
              ry="5"
              width="50"
              height="10"
            />
            <rect
              x="60%"
              y={20 + 50 * row}
              rx="5"
              ry="5"
              width={Math.random() * (100 - 50) + 50}
              height="10"
            />
            <rect
              x="70%"
              y={20 + 50 * row}
              rx="5"
              ry="5"
              width="100"
              height="10"
            />
            <circle cx="83%" cy={25 + 50 * row} r="22" />
            <circle cx="88%" cy={25 + 50 * row} r="17" />
            <circle cx="92%" cy={25 + 50 * row} r="17" />
            <circle cx="95%" cy={25 + 50 * row} r="17" />
            <circle cx="98%" cy={25 + 50 * row} r="17" />
          </React.Fragment>
        ))}
    </ContentLoader>
  );
};

const Loader = () => {
  return (
    <div style={{ padding: '1rem', height: '100%' }}>
      <Header />
      <Table />
    </div>
  );
};

export default Loader;
